import React from 'react'

const MetadataBooleanValue: React.FC<{ value: boolean }> = ({ value }) => (
    <>{value ? 'TRUE' : 'FALSE'}</>
)

export default MetadataBooleanValue
